import React from 'react';
import jsPDF from 'jspdf';

export const InstructionsPDF = () => {
  var doc = new jsPDF();

  doc.setFontSize(18);
  doc.text('Fly Louie FBO Portal Instructions', 45, 20);

  doc.setFontSize(16);
  doc.text('Tail Number or Operator Lookup', 10, 35);
  doc.setFontSize(12);
  doc.text(`This page allows users to determine whether an aircraft is a part ` +
    `of the Fly Louie Fuel Program.\n\n` +
    `Enter any tail number in the search field. If the tail number is found ` +
    `to be in the Alliance, the user\n` +
    `will see a table with the Operator Name, Avfuel account name, and all ` +
    `associated Avfuel “Bill-To”\n` +
    `codes. If an aircraft shows multiple accounts, the FBO must verify the ` +
    `appropriate account with the\n` +
    `crew or dispatcher.`,
    10, 45
  )

  doc.setFontSize(16);
  doc.text('Add New FBO Portal Users', 10, 80);
  doc.setFontSize(12);
  doc.text(`This page allows users to add new FBO Portal Users.  Enter the ` +
  `requested information and click\n` +
  `"submit".  You will need to select if the ` +
  `new User should be an "Admin" User or a "Normal" User.\n` +
  `Admin Users are also authorized to view historical activity statements ` +
  `from Fly Louie and a full\n` +
  `list of Users on the account.\n\n` +
  `After clicking "Submit", an email will be sent to the new User prompting ` +
  `them to set up their account.`,
    10, 90
  )

  doc.setFontSize(16);
  doc.text('User List', 10, 125);
  doc.setFontSize(12);
  doc.text(`This page provides a list of all users on the account.  You may ` +
  `edit or delete any existing User\n` +
  `by clicking the applicable link. `,
    10, 135
  )

  doc.setFontSize(16);
  doc.text('Statements', 10, 150);
  doc.setFontSize(12);
  doc.text(`This page provides access to the FBO's historical activity ` +
  `statements from Fly Louie for the past\n` +
  `12 months.  You may view or print any statement by selecting "View PDF".`,
    10, 160
  )

  doc.save('fly_louie_fbo_portal_instructions.pdf');
  return true
}